export interface GAPageMapping {
  url: string;
  pagename: string;
  section: string;
}

export interface GAPageMapping {
  url: string;
  pagename: string;
  section: string;
}

export const GA_PAGE_MAPPINGS: GAPageMapping[] = [
  {
    url: '/user/userlistview',
    pagename: 'avr:manage:user:userlistview',
    section: 'manage',
  },
  {
    url: '/entity/entity',
    pagename: 'avr:manage:entity',
    section: 'manage',
  },
  {
    url: '/project/project',
    pagename: 'avr:manage:project',
    section: 'manage',
  },
  {
    url: '/project/createproject',
    pagename: 'avr:manage:project:createproject',
    section: 'manage',
  },
  {
    url: '/project/editproject',
    pagename: 'avr:manage:project:editproject',
    section: 'manage',
  },
  {
    url: '/domaindashboard/domaindashboard',
    pagename: 'avr:dashboard:domaindashboard',
    section: 'dashboard',
  },
  {
    url: '/ice/datasets',
    pagename: 'avr:dataimports:ice:datasets',
    section: 'dataimports',
  },
  {
    url: '/tagsandfolders/tagsandfolders',
    pagename: 'avr:manage:tagsandfolders',
    section: 'manage',
  },
  {
    url: '/keywords/keywords',
    pagename: 'avr:manage:keywords',
    section: 'manage',
  },
  {
    url: '/comments/commentslist',
    pagename: 'avr:manage:comments:commentslist',
    section: 'manage',
  },
  {
    url: '/redaction/redaction',
    pagename: 'avr:manage:redaction',
    section: 'manage',
  },
  {
    url: '/securitygroups/securitygroups',
    pagename: 'avr:manage:securitygroups',
    section: 'manage',
  },
  {
    url: '/project/createiprestriction',
    pagename: 'avr:manage:project:createiprestriction',
    section: 'manage',
  },
  {
    url: '/projectfields/projectfieldslist',
    pagename: 'avr:manage:projectfields:projectfieldslist',
    section: 'manage',
  },
  {
    url: '/annotations/annotations',
    pagename: 'avr:manage:annotations',
    section: 'manage',
  },
  {
    url: '/savedsearch/savedsearches',
    pagename: 'avr:search:savedsearch:savedsearches',
    section: 'search',
  },
  {
    url: '/production/home',
    pagename: 'avr:exports:production:home',
    section: 'exports',
  },
  {
    url: '/production/home/new',
    pagename: 'avr:exports:production:home:new',
    section: 'exports',
  },
  {
    url: '/production/home/edit',
    pagename: 'avr:exports:production:home:edit',
    section: 'exports',
  },
  {
    url: '/production/home/reproduction',
    pagename: 'avr:exports:production:home:reproduction',
    section: 'exports',
  },
  {
    url: '/production/linkexpired',
    pagename: 'avr:exports:production:linkexpired',
    section: 'exports',
  },
  {
    url: '/production/downloaderror',
    pagename: 'avr:exports:production:downloaderror',
    section: 'exports',
  },
  {
    url: '/data/:key',
    pagename: 'avr:exports:data:key',
    section: 'exports',
  },
  {
    url: '/prod/:key',
    pagename: 'avr:exports:prod:key',
    section: 'exports',
  },
  {
    url: '/batchprint',
    pagename: 'avr:exports:batchprint',
    section: 'exports',
  },
  {
    url: '/proview/proview',
    pagename: 'avr:categorize:proview',
    section: 'categorize',
  },
  {
    url: '/report/reportslanding',
    pagename: 'avr:reports:report:reportslanding',
    section: 'reports',
  },
  {
    url: '/dataanalysisreport/communicationexplorerreport',
    pagename: 'avr:reports:dataanalysisreport:communicationexplorerreport',
    section: 'reports',
  },
  {
    url: '/dataanalysisreport/conceptexplorer',
    pagename: 'avr:reports:dataanalysisreport:conceptexplorer',
    section: 'reports',
  },
  {
    url: '/dataanalysisreport/searchtermreport',
    pagename: 'avr:reports:dataanalysisreport:searchtermreport',
    section: 'reports',
  },
  {
    url: '/report/tally',
    pagename: 'avr:reports:report:tally',
    section: 'reports',
  },
  {
    url: '/report/timeline',
    pagename: 'avr:reports:report:timeline',
    section: 'reports',
  },
  {
    url: '/review/reviewresults',
    pagename: 'avr:reports:review:reviewresults',
    section: 'reports',
  },
  {
    url: '/review/reviewercountsreport',
    pagename: 'avr:reports:review:reviewercountsreport',
    section: 'reports',
  },
  {
    url: '/review/reviewerproductivityreport',
    pagename: 'avr:reports:review:reviewerproductivityreport',
    section: 'reports',
  },
  {
    url: '/review/reviewertimeonline',
    pagename: 'avr:reports:review:reviewertimeonline',
    section: 'reports',
  },
  {
    url: '/review/tagcountsbytagreport',
    pagename: 'avr:reports:review:tagcountsbytagreport',
    section: 'reports',
  },
  {
    url: '/report/exportdata',
    pagename: 'avr:reports:report:exportdata',
    section: 'reports',
  },
  {
    url: '/review/documentaudit',
    pagename: 'avr:reports:review:documentaudit',
    section: 'reports',
  },
  {
    url: '/review/userloginactivityreport',
    pagename: 'avr:reports:review:userloginactivityreport',
    section: 'reports',
  },
  {
    url: '/review/useractivity',
    pagename: 'avr:reports:review:useractivity',
    section: 'reports',
  },
  {
    url: '/report/export/view',
    pagename: 'avr:reports:report:export:view',
    section: 'reports',
  },
  {
    url: '/dashboard/dashboard',
    pagename: 'avr:dashboard',
    section: 'dashboard',
  },
  {
    url: '/assignment/manageassignment',
    pagename: 'avr:manage:assignment:manageassignment',
    section: 'manage',
  },
  {
    url: '/assignment/create',
    pagename: 'avr:manage:assignment:create',
    section: 'manage',
  },
  {
    url: '/assignment/edit',
    pagename: 'avr:manage:assignment:edit',
    section: 'manage',
  },
  {
    url: '/batchredaction/batchredaction',
    pagename: 'avr:manage:batchredaction',
    section: 'manage',
  },
  {
    url: '/codingform/create',
    pagename: 'avr:manage:codingform:create',
    section: 'manage',
  },
  {
    url: '/review/advancedbatchmanagementreport',
    pagename: 'avr:reports:review:advancedbatchmanagementreport',
    section: 'reports',
  },
  {
    url: '/review/assignmentprogressreport',
    pagename: 'avr:reports:review:assignmentprogressreport',
    section: 'reports',
  },
  {
    url: '/review/reviewerprogressreport',
    pagename: 'avr:reports:review:reviewerprogressreport',
    section: 'reports',
  },
  {
    url: '/reviewerdashboard/index',
    pagename: 'avr:dashboard:reviewerdashboard:index',
    section: 'dashboard',
  },
];
 
